import React, { useState } from "react";
import { useLang } from "../context/LanguageContext";
import {
  Music, Theater, BookMarked, Monitor, Bot, Atom, Dumbbell, Waves, Drama,
} from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "./ui/dialog";

const iconMap = {
  music: Music,
  dance: Drama,
  theatre: Theater,
  book: BookMarked,
  computer: Monitor,
  robot: Bot,
  atom: Atom,
  sport: Dumbbell,
  swim: Waves,
};
const colors = ["#1E5FBA", "#E63946", "#FFD500", "#2E9E4E", "#1D3557", "#1E5FBA", "#E63946", "#FFD500", "#2E9E4E"];

const Activities = () => {
  const { t } = useLang();
  const [openIdx, setOpenIdx] = useState(null);
  const active = openIdx !== null ? t.activities.items[openIdx] : null;
  const activeColor = openIdx !== null ? colors[openIdx % colors.length] : "#1E5FBA";
  const ActiveIcon = active ? (iconMap[active.emoji] || Music) : null;

  return (
    <section id="actividades" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#E63946] mb-4">
            {t.activities.overline}
          </div>
          <h2 className="font-fredoka text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] text-[#1D3557]">
            {t.activities.title}
          </h2>
          <p className="mt-4 text-sm md:text-base text-[#457B9D]">
            Haz clic en cualquier actividad para conocer más.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-6">
          {t.activities.items.map((item, i) => {
            const Icon = iconMap[item.emoji] || Music;
            const color = colors[i % colors.length];
            return (
              <button
                key={i}
                type="button"
                onClick={() => setOpenIdx(i)}
                data-testid={`activity-${item.emoji}`}
                className="group text-left relative rounded-[1.75rem] p-6 md:p-8 bg-white border border-[#E2E8F0]/70 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_rgba(29,53,87,0.1)] transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1E5FBA]"
              >
                <div
                  className="w-14 h-14 md:w-16 md:h-16 rounded-2xl grid place-items-center mb-5 transition-transform group-hover:scale-110"
                  style={{ backgroundColor: `${color}1a` }}
                >
                  <Icon className="w-7 h-7 md:w-8 md:h-8" strokeWidth={2.5} style={{ color }} />
                </div>
                <div className="font-fredoka text-lg md:text-xl font-semibold text-[#1D3557]">
                  {item.name}
                </div>
                <div className="mt-2 text-xs font-semibold uppercase tracking-widest text-[#457B9D] opacity-0 group-hover:opacity-100 transition-opacity">
                  Ver más →
                </div>
              </button>
            );
          })}
        </div>
      </div>

      <Dialog open={openIdx !== null} onOpenChange={(o) => !o && setOpenIdx(null)}>
        <DialogContent
          data-testid="activity-dialog"
          className="sm:max-w-lg rounded-[1.75rem] border-0 bg-white p-0 overflow-hidden"
        >
          {active && ActiveIcon && (
            <>
              <div
                className="relative px-8 pt-10 pb-8 text-white"
                style={{
                  background: `linear-gradient(135deg, ${activeColor} 0%, ${activeColor}dd 100%)`,
                }}
              >
                <div className="w-20 h-20 rounded-3xl bg-white/20 grid place-items-center mb-5 backdrop-blur">
                  <ActiveIcon className="w-10 h-10 text-white" strokeWidth={2.5} />
                </div>
                <DialogHeader>
                  <DialogTitle className="font-fredoka text-3xl md:text-4xl font-semibold text-white text-left">
                    {active.name}
                  </DialogTitle>
                </DialogHeader>
              </div>
              <div className="px-8 py-8">
                <DialogDescription className="text-base leading-relaxed text-[#457B9D]">
                  {active.description}
                </DialogDescription>
                <a
                  href="#contacto"
                  onClick={() => setOpenIdx(null)}
                  data-testid="activity-dialog-cta"
                  className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#1D3557] hover:bg-[#1E5FBA] text-white px-6 py-3 text-sm font-semibold transition-colors"
                >
                  Agenda una visita
                </a>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Activities;
